<form
    *ngIf="setting && provider"
    #shareForm="ngForm"
    class="form-v2 aside-nav-v2 generic-provider"
    (ngSubmit)="submitForm(shareForm)"
    (appClickOutsidePanels)="cancel(shareForm)"
    [excludedClasses]="'ng-option'"
    [excludeDatePicker]="true"
    [enableClickOut]="true"
    ngNativeValidate>
    <header class="modal-header">
        <h4 class="modal-title">{{ provider }} Settings</h4>
    </header>
    <div class="modal-body side-panel-body">
        <section class="form-section">
            <h4 class="modal-title">Choose what gets synced to {{ provider }}</h4>
            <div class="form-group row">
                <div class="checkbox">
                    <input
                        legacy-css
                        type="checkbox"
                        id="syncPurchaseOrders"
                        [(ngModel)]="setting.isPurchaseOrdersSync"
                        name="IsPurchaseOrdersSync" />
                    <label for="syncPurchaseOrders"> Sync 'Received' Purchase Orders </label>
                </div>
                <div class="checkbox">
                    <input legacy-css type="checkbox" id="syncInvoices" [(ngModel)]="setting.isInvoicesSync" name="IsInvoicesSync" />
                    <label for="syncInvoices"> Sync 'Invoiced' Job Invoices </label>
                </div>
                <span class="error-msg" *ngIf="!setting.isInvoicesSync && !setting.isPurchaseOrdersSync"
                    >By unselecting both, your accounts will not be syncing for the time being</span
                >
            </div>
            <div class="form-group date-picker-hide-clear row">
                <label class="col-xs-12 mandatory-field" [ngClass]="{ 'has-focus': focused.startDate }"> I want to sync items from: </label>
                <div class="col-xs-12">
                    <input
                        legacy-css
                        bsDatepicker
                        [bsConfig]="{
                            adaptivePosition: true,
                            showWeekNumbers: false,
                            containerClass: 'theme-default',
                            customTodayClass: 'bsdatepicker-today',
                            dateInputFormat: locale,
                        }"
                        type="text"
                        class="form-control form-control-v2"
                        (focus)="focused.startDate = true"
                        (blur)="focused.startDate = false"
                        (bsValueChange)="changeDate($event)"
                        (ngModelChange)="syncStartDate = startDate._bsValue"
                        [ngModel]="syncStartDate"
                        #startDate="bsDatepicker"
                        id="startDate"
                        name="startDate"
                        required />
                </div>
            </div>
        </section>
        <section class="form-section">
            <h4>For Purchase Orders that have been received by suppliers and contractors</h4>
            <div class="form-group row">
                <label
                    class="col-xs-12"
                    [ngClass]="{ 'has-focus': focused.purchaseOrderAccountCode, 'mandatory-field': setting.isPurchaseOrdersSync }">
                    Expense account for suppliers
                </label>
                <div class="col-xs-12 margin-bottom-10">
                    <ng-select
                        class="light"
                        name="PurchaseOrderAccountCode"
                        [items]="expenseAccounts"
                        labelForId="PurchaseOrderAccountCode"
                        #purchaseOrderAccountCode="ngModel"
                        (focus)="focused.purchaseOrderAccountCode = true"
                        (blur)="focused.purchaseOrderAccountCode = false"
                        bindValue="code"
                        bindLabel="fullname"
                        [clearable]="false"
                        placeholder="Please select"
                        [(ngModel)]="setting.purchaseOrderAccountCode"
                        [required]="setting.isPurchaseOrdersSync">
                        <ng-template ng-label-tmp let-item="item">
                            {{ item.fullname }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            {{ item.fullname }}
                        </ng-template>
                    </ng-select>
                </div>
                <label
                    class="col-xs-12"
                    [ngClass]="{
                        'has-focus': focused.purchaseOrderAccountCodeContractor,
                        'mandatory-field': setting.isPurchaseOrdersSync,
                    }">
                    Expense account for contractors
                </label>
                <div class="col-xs-12 margin-bottom-10">
                    <ng-select
                        class="light"
                        name="PurchaseOrderAccountCodeContractor"
                        [items]="expenseAccounts"
                        labelForId="PurchaseOrderAccountCodeContractor"
                        #purchaseOrderAccountCodeContractor="ngModel"
                        (focus)="focused.purchaseOrderAccountCodeContractor = true"
                        (blur)="focused.purchaseOrderAccountCodeContractor = false"
                        bindValue="code"
                        bindLabel="fullname"
                        [clearable]="false"
                        placeholder="Please select"
                        [(ngModel)]="setting.purchaseOrderAccountCodeContractor"
                        [required]="setting.isPurchaseOrdersSync">
                        <ng-template ng-label-tmp let-item="item">
                            {{ item.fullname }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            {{ item.fullname }}
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="form-group row">
                <hr class="dark margin-bottom-15" />
                <div>
                    <label
                        class="col-xs-9"
                        [ngClass]="{ 'has-focus': focused.taxRateExpenseTaxable, 'mandatory-field': setting.isPurchaseOrdersSync }">
                        For Default {{ provider }} Expense Tax type:
                    </label>
                    <div class="pull-right">
                        <help-note-wrapper
                            [title]="'Tax code'"
                            [applyAsideNav]="true"
                            [url]="'accountSync.helpNote.url' | translate"
                            [footer]="'taxProfiles.helpNote.footer' | translate">
                            The default tax code that will be applied
                        </help-note-wrapper>
                    </div>
                    <div class="col-xs-12 margin-bottom-10">
                        <ng-select
                            class="light"
                            [items]="taxRates"
                            name="TaxRateExpenseTaxable"
                            labelForId="TaxRateExpenseTaxable"
                            #taxRateExpenseTaxable="ngModel"
                            (focus)="focused.taxRateExpenseTaxable = true"
                            (blur)="focused.taxRateExpenseTaxable = false"
                            [clearable]="false"
                            placeholder="Please select"
                            [(ngModel)]="setting.taxRateExpenseTaxable"
                            bindValue="name"
                            [required]="setting.isPurchaseOrdersSync">
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div>
                    <label
                        class="col-xs-9"
                        [ngClass]="{ 'has-focus': focused.taxRateExpenseFree, 'mandatory-field': setting.isPurchaseOrdersSync }">
                        For Default {{ provider }} Expense Tax Free type:
                    </label>
                    <div class="pull-right">
                        <help-note-wrapper
                            [title]="'Tax code'"
                            [applyAsideNav]="true"
                            [url]="'accountSync.helpNote.url' | translate"
                            [footer]="'taxProfiles.helpNote.footer' | translate">
                            The default tax code that will be applied
                        </help-note-wrapper>
                    </div>
                    <div class="col-xs-12 margin-bottom-10">
                        <ng-select
                            class="light"
                            [items]="taxRates"
                            name="TaxRateExpenseFree"
                            labelForId="TaxRateExpenseFree"
                            #taxRateExpenseFree="ngModel"
                            (focus)="focused.taxRateExpenseFree = true"
                            (blur)="focused.taxRateExpenseFree = false"
                            [clearable]="false"
                            placeholder="Please select"
                            [(ngModel)]="setting.taxRateExpenseFree"
                            bindValue="name"
                            [required]="setting.isPurchaseOrdersSync">
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <hr class="dark margin-bottom-15" />
                <div *ngFor="let code of expenseTaxCodes">
                    <label
                        class="col-xs-9"
                        [ngClass]="{ 'has-focus': focused.taxExpenseCode, 'mandatory-field': setting.isPurchaseOrdersSync }">
                        For {{ code.taxDescription }} ({{ code.taxCode }}), use {{ provider }} tax type:
                    </label>
                    <div class="pull-right">
                        <help-note-wrapper
                            [title]="'Tax code'"
                            [applyAsideNav]="true"
                            [url]="'accountSync.helpNote.url' | translate"
                            [footer]="'taxProfiles.helpNote.footer' | translate">
                            <div *ngFor="let profile of code.taxProfiles">
                                Tax code {{ profile.description }} ({{ profile.rate | percent: '1.0-2' }}) from Tax Profile
                                {{ profile.profileDescription }} applies to
                                <span *ngFor="let default of profile.defaults; let i = index">
                                    {{ 'costItemTypes.' + default | translate }}{{ i === profile.defaults.length - 1 ? '.' : ', ' }}
                                </span>
                                <span *ngIf="profile.defaults.length === 0"> nothing. </span>
                            </div>
                        </help-note-wrapper>
                    </div>
                    <div class="col-xs-12 margin-bottom-10">
                        <ng-select
                            class="light"
                            [name]="'Expense_' + code.taxCode"
                            [items]="taxRates"
                            labelForId="'Expense_' + code.taxCode"
                            #taxExpenseCode="ngModel"
                            (focus)="focused.taxExpenseCode = true"
                            (blur)="focused.taxExpenseCode = false"
                            [clearable]="false"
                            placeholder="Please select"
                            [(ngModel)]="results.expense[code.taxCode]"
                            [required]="setting.isPurchaseOrdersSync">
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
        </section>
        <section class="form-section">
            <h4>For job invoices that have been invoiced to clients</h4>
            <div class="form-group row">
                <label class="col-xs-12" [ngClass]="{ 'has-focus': focused.invoiceAccountCode, 'mandatory-field': setting.isInvoicesSync }">
                    Use {{ provider }} income account
                </label>
                <div class="col-xs-12 margin-bottom-10">
                    <ng-select
                        class="light"
                        name="invoiceAccountCode"
                        [items]="incomeAccounts"
                        bindValue="code"
                        bindLabel="fullname"
                        labelForId="invoiceAccountCode"
                        #invoiceAccountCode="ngModel"
                        (focus)="focused.invoiceAccountCode = true"
                        (blur)="focused.invoiceAccountCode = false"
                        [clearable]="false"
                        placeholder="Please select"
                        [(ngModel)]="setting.invoiceAccountCode"
                        [required]="setting.isInvoicesSync">
                        <ng-template ng-label-tmp let-item="item">
                            {{ item.fullname }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            {{ item.fullname }}
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="form-group row" *ngIf="provider.toLowerCase() === 'xero'">
                <label
                    class="col-xs-12"
                    [ngClass]="{ 'has-focus': focused.defaultInvoiceStatus, 'mandatory-field': setting.isInvoicesSync }">
                    {{ provider }} default invoice status
                </label>
                <div class="col-xs-12 margin-bottom-10">
                    <ng-select
                        class="light"
                        name="DefaultInvoiceStatus"
                        [items]="defaultInvoiceStatuses"
                        labelForId="DefaultInvoiceStatus"
                        #defaultInvoiceStatus="ngModel"
                        (focus)="focused.defaultInvoiceStatus = true"
                        (blur)="focused.defaultInvoiceStatus = false"
                        [clearable]="false"
                        placeholder="Please select"
                        [(ngModel)]="setting.defaultInvoiceStatus"
                        [required]="setting.isInvoicesSync">
                    </ng-select>
                </div>
            </div>
            <hr class="dark margin-bottom-15" />
            <div class="form-group row">
                <div>
                    <label
                        class="col-xs-9"
                        [ngClass]="{ 'has-focus': focused.taxRateIncomeTaxable, 'mandatory-field': setting.isInvoicesSync }">
                        For Default {{ provider }} Income Tax type:
                    </label>
                    <div class="pull-right">
                        <help-note-wrapper
                            [title]="'Tax code'"
                            [applyAsideNav]="true"
                            [url]="'accountSync.helpNote.url' | translate"
                            [footer]="'taxProfiles.helpNote.footer' | translate">
                            The default tax code that will be applied
                        </help-note-wrapper>
                    </div>
                    <div class="col-xs-12 margin-bottom-10">
                        <ng-select
                            class="light"
                            [items]="taxRates"
                            name="TaxRateIncomeTaxable"
                            labelForId="TaxRateIncomeTaxable"
                            #taxRateIncomeTaxable="ngModel"
                            (focus)="focused.taxRateIncomeTaxable = true"
                            (blur)="focused.taxRateIncomeTaxable = false"
                            [clearable]="false"
                            placeholder="Please select"
                            [(ngModel)]="setting.taxRateIncomeTaxable"
                            bindValue="name"
                            [required]="setting.isInvoicesSync">
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div>
                    <label
                        class="col-xs-9"
                        [ngClass]="{ 'has-focus': focused.taxRateIncomeFree, 'mandatory-field': setting.isInvoicesSync }">
                        For Default {{ provider }} Income Tax Free type:
                    </label>
                    <div class="pull-right">
                        <help-note-wrapper
                            [title]="'Tax code'"
                            [applyAsideNav]="true"
                            [url]="'accountSync.helpNote.url' | translate"
                            [footer]="'taxProfiles.helpNote.footer' | translate">
                            The default tax code that will be applied
                        </help-note-wrapper>
                    </div>
                    <div class="col-xs-12 margin-bottom-10">
                        <ng-select
                            class="light"
                            [items]="taxRates"
                            name="TaxRateIncomeFree"
                            labelForId="TaxRateIncomeFree"
                            #taxRateIncomeFree="ngModel"
                            (focus)="focused.taxRateIncomeFree = true"
                            (blur)="focused.taxRateIncomeFree = false"
                            [clearable]="false"
                            placeholder="Please select"
                            [(ngModel)]="setting.taxRateIncomeFree"
                            bindValue="name"
                            [required]="setting.isInvoicesSync">
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <hr class="dark margin-bottom-15" />
                <div *ngFor="let code of incomeTaxCodes">
                    <label class="col-xs-9" [ngClass]="{ 'has-focus': focused.incomeTaxCode, 'mandatory-field': setting.isInvoicesSync }">
                        For {{ code.taxDescription }} ({{ code.taxCode }}), use {{ provider }} tax type:
                    </label>
                    <div class="pull-right">
                        <help-note-wrapper
                            [title]="'Tax code'"
                            [applyAsideNav]="true"
                            [url]="'accountSync.helpNote.url' | translate"
                            [footer]="'taxProfiles.helpNote.footer' | translate">
                            <div *ngFor="let profile of code.taxProfiles">
                                Tax code {{ profile.description }} ({{ profile.rate | percent: '1.0-2' }}) from Tax Profile
                                {{ profile.profileDescription }} applies to
                                <span *ngFor="let default of profile.defaults; let i = index">
                                    {{ 'costItemTypes.' + default | translate }}{{ i === profile.defaults.length - 1 ? '.' : ', ' }}
                                </span>
                                <span *ngIf="profile.defaults.length === 0"> nothing. </span>
                            </div>
                        </help-note-wrapper>
                    </div>
                    <div class="col-xs-12 margin-bottom-10">
                        <ng-select
                            class="light"
                            [name]="'Income_' + code.taxCode"
                            [items]="taxRates"
                            labelForId="'Income_' + code.taxCode"
                            #incomeTaxCode="ngModel"
                            (focus)="focused.incomeTaxCode = true"
                            (blur)="focused.incomeTaxCode = false"
                            [clearable]="false"
                            placeholder="Please select"
                            [(ngModel)]="results.income[code.taxCode]"
                            [required]="setting.isInvoicesSync">
                            <ng-template ng-label-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.name }} ({{ item.rate / 100 | percent: '1.0-2' }})
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="form-group row" *ngIf="provider.toLowerCase() === 'xero'">
                <label class="col-xs-12" [ngClass]="{ 'has-focus': focused.trackingCategory }">
                    {{ provider }} tracking category to use for job numbers:
                </label>
                <div class="col-xs-12 margin-bottom-10">
                    <ng-select
                        class="light"
                        name="TrackingCategory"
                        [items]="trackingCategories"
                        #trackingCategory="ngModel"
                        (focus)="focused.trackingCategory = true"
                        (blur)="focused.trackingCategory = false"
                        [clearable]="false"
                        placeholder="Please select"
                        bindLabel="label"
                        bindValue="value"
                        [(ngModel)]="setting.jobTrackingCategory">
                    </ng-select>
                </div>
            </div>
        </section>
    </div>
    <footer class="modal-footer">
        <button type="button" class="btn-bx-secondary-stroked" (click)="cancel(shareForm)">Cancel</button>
        <button type="submit" class="btn-bx-primary ml-2" [disabled]="!shareForm.form.valid">Save Settings and Close</button>
    </footer>
</form>
